<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >
              {{ $t("mcg.edit") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-start pt-5>
            <v-flex xs11 lg7 pa-3>
              <v-card class="rounded-lg">
                <v-card-title primary-title>
                  {{ $t("mcg.editinfor") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap justify-center align-center pa-6>
                    <v-flex xs11 lg11>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("mcg.row2") }}</b> <br />
                      <v-text-field
                        outlined
                        dense
                        color="info"
                        v-model="GroupName"
                        :label="$t('mcg.spegroupname')"
                        :rules="[(v) => !!v || $t('mcg.spegroupname2')]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs11 lg11>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("dashboard.policy") }} </b>
                      <span class="grey--text">{{ $t("mcg.policy1") }}</span>
                    </v-flex>
                    <!-- Policy -->
                    <v-flex xs11 lg11>
                      <v-autocomplete
                        return-object
                        item-text="Title"
                        item-value="PolicyId"
                        :items="ItemPolicy"
                        v-model="SelectPolicy"
                        deletable-chips
                        color="info"
                        outlined
                        dense
                        chips
                        small-chips
                        :label="$t('mcg.policy2')"
                        :rules="[(v) => !!v || $t('mcg.policy3')]"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs11 lg11>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("consentform.exdate") }}</b>
                      <br />
                      <v-text-field
                        color="#077893"
                        :label="$t('consentlist.expiration')"
                        :oninput="rulesObject.numRegex"
                        v-model="ExpirationDate"
                        :rules="[(v) => !!v || $t('consentform.exdate2')]"
                        maxlength="2"
                        onkeyup="if(this.value > 10) this.value = 10;"
                        outlined
                        dense
                        clearable
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs11 lg11>
                      <v-row>
                        <v-col cols="12" md="12">
                          <b class="red--text mr-1">*</b>
                          <b v-if="$t('default') === 'th'"
                            >ข้อมูลที่ต้องการขอ
                          </b>
                          <b v-else>Personal Data to Request </b>
                          <v-combobox
                            color="#077893"
                            v-model="itemsRequest"
                            :items="itemsRequest"
                            required
                            persistent-hint
                            append-icon=""
                            hide-selected
                            multiple
                            outlined
                            dense
                            clearable
                            small-chips
                            deletable-chips
                            :rules="[required]"
                          >
                          </v-combobox>
                        </v-col>
                      </v-row>
                    </v-flex>
                    <!-- example Consent-->
                    <v-flex xs11 lg11 pt-4>
                      <v-card outlined>
                        <v-card-text>
                          <b style="text-decoration: underline">{{
                            $t("mcg.example")
                          }}</b>
                          <div
                            v-for="(item, index) in ItemsData"
                            :key="index"
                            style="display: inline"
                          >
                            <span class="black--text pl-3 FontSize">
                              {{ item.Text }},
                            </span>
                          </div>
                          <draggable
                            :list="ItemsData"
                            :disabled="!Enabled"
                            class="list-group move"
                            ghost-class="ghost"
                            :move="Fn_CheckMove(ItemsData)"
                            @start="Dragging = true"
                            @end="Dragging = false"
                          >
                            <div
                              class="list-group-item"
                              v-for="(item, index) in ItemsData"
                              :key="index + 1"
                            >
                              <v-card color="#ddf7ff" class="elevation-0 ma-3">
                                <v-card-text>
                                  <v-layout row wrap align-center>
                                    <v-flex xs10 lg10 text-left>
                                      <b> {{ item.Text }}</b>
                                    </v-flex>
                                    <v-flex xs2 lg2>
                                      <v-btn
                                        color="red"
                                        fab
                                        small
                                        dark
                                        depressed
                                        @click="Fn_Delete(index)"
                                      >
                                        <v-icon>mdi-delete-outline</v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </div>
                          </draggable>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs11 md11 lg11 pt-3>
                      <b v-if="$t('default') === 'th'" class="red--text">
                        หมายเหตุ :
                        หากบันทึกแล้วจะไม่สามารถแก้ไขกลุ่มความยินยอมได้</b
                      >
                      <b v-else class="red--text"
                        >Note: Once saved, the consent group cannot be
                        edited.</b
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    mt-n6
                    pa-2
                    pb-4
                  >
                    <v-flex lg3 md3 sm3 xs3>
                      <v-btn
                        block
                        dark
                        color="#077893"
                        v-model="Manage"
                        @click="save_draft"
                        :loading="loadingDraft"
                        >{{ $t("policy.text5") }}</v-btn
                      >
                    </v-flex>
                    <v-flex lg3 md3 sm3 xs3 mx-1 v-if="DissabledRole == false">
                      <v-btn
                        block
                        dark
                        color="#077893"
                        v-model="Manage"
                        @click="save_enable"
                        :loading="loadingEnable"
                        >{{ $t("policy.text10") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs11 lg4 pa-3>
              <v-card class="rounded-lg">
                <v-card-text>
                  <!-- <b class="red--text mr-1">*</b> -->
                  <b>{{ $t("Toolbar.consent") }} </b>
                  <span class="grey--text ml-2"> {{ $t("mcg.consent1") }}</span>
                </v-card-text>
                <v-card-text>
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs11 lg11>
                      <v-textarea
                        color="#077893"
                        outlined
                        :label="$t('consentform.brief')"
                        counter="500"
                        v-model="Title"
                      ></v-textarea>
                      <!-- :rules="[
                          (v) => !!v || $t('mcg.consent3'),
                          (v) => v.length <= 500 || $t('consentform.brief3'),
                        ]" -->
                    </v-flex>
                    <v-flex xs11 lg11>
                      <v-autocomplete
                        item-text="HeaderConsent"
                        item-value="ConsentId"
                        :items="ItemConsent"
                        v-model="SelectConsent"
                        outlined
                        dense
                        chips
                        return-object
                        small-chips
                        multiple
                        :label="$t('mcg.consent2')"
                        @change="Fn_AddConsent"
                        :rules="[(v) => !!v || $t('mcg.consent3')]"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
        <div v-if="loadingDownloadData">
          <OverlaySearch :title="ShowTitle" :detail="ShowText" />
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPending.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { draggable, OverlaySearch },
  data: function () {
    return {
      valid: true,
      Enabled: true,
      Dragging: false,
      LoadingPolicy: false,
      ItemsData: [],
      ItemPolicy: [],
      ItemConsent: [],
      GroupName: "",
      Content: "",
      ConsentId: "",
      GroupDefault: [],
      GroupSelect: [],
      SelectPolicy: "",
      SelectConsent: "",
      DataConsent: [],
      Consent: [],
      Manage: "",
      indexMove: 0,
      ExpirationDate: "",
      ShowTitle: "โปรดรอสักครู่...",
      ShowText:
        "ระบบกำลังดำเนินการแจ้งเตือนเพื่อขออนุมัติการสร้างกลุ่มความยินยอม",
      rulesObject: {
        numRegex: "this.value = this.value.replace(/[^0-9.]|/g, '').substr()",
      },
      Role: [],
      Title: "",
      addRequest: [],
      itemsRequest: [],
      addRequestFix: "",
      DissabledRole: true,
      loadingDraft: false,
      loadingEnable: false,
      loadingDownloadData: false,
    };
  },
  computed: {
    ...mapGetters(["DataConsentGroup"]),
    ...mapGetters(["RoleAccount"]),
    ...mapGetters(["Business"]),
    DataCheckRole: {
      get() {
        return this.$store.state.DataCheckRole;
      },
    },
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    draggingInfo() {
      return this.Dragging ? "under drag" : "";
    },
    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    _GroupId: {
      get() {
        return this.DataConsentGroup.GroupId || "-";
      },
    },
  },
  mounted() {
    this.Fn_CheckRole();
    this.Fn_GetDataPolicy();
    this.Fn_GetDataConsent();
    this.Fn_GetDataConsentGroup();
  },
  methods: {
    async Fn_CheckRole() {
      var payload = {
        TaxId: this.$cookies.get("TaxIdCMP"),
      };

      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetBusinessCheckRoleApprove",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.Role = response.data.Message.RoleApprove;
            if (this.Role.length === 0) {
              this.DissabledRole = false;
            } else {
              this.DissabledRole = true;
            }
            const roleArray = Array.isArray(this.Role)
              ? this.Role
              : [this.Role];
            const roleLowerCase = roleArray.map((role) => role.toLowerCase());

            const dataCheckRoleArray = Array.isArray(this.DataCheckRole)
              ? this.DataCheckRole
              : [this.DataCheckRole];
            const dataCheckRoleLowerCase = dataCheckRoleArray.map((role) =>
              role.toLowerCase()
            );

            const isSimilar = roleLowerCase.some((role) =>
              dataCheckRoleLowerCase.includes(role)
            );

            if (isSimilar === true || this.Role.length === 0) {
              this.DissabledRole = false;
            } else {
              this.DissabledRole = true;
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_CheckMove: function (e) {
      e.forEach((element, index) => {
        element.Level = index + 1;
      });
      this.ItemsData = e;
    },
    Fn_AddConsent() {
      this.ItemsData = [];
      var index = 0;
      for (var i in this.SelectConsent) {
        index += 1;
        this.GroupSelect = {
          ConsentId: this.SelectConsent[i].ConsentId,
          Level: index,
          Text: this.SelectConsent[i].HeaderConsent,
        };
        this.ItemsData.push(this.GroupSelect);
      }
    },
    Fn_Delete(i) {
      this.SelectConsent.splice(i, 1);
      this.ItemsData.splice(i, 1);
    },
    async Fn_GetDataPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: +JSON.stringify(error.response.data.ErrorMessage),
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDataConsent() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsent = response.data.Message;

          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: +JSON.stringify(error.response.data.ErrorMessage),
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDataConsentGroup() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        GroupId: this._GroupId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetDetailGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.DataGroup = response.data.Message;

            this.GroupName = response.data.Message.GroupName;
            this.SelectPolicy = response.data.Message.Policy;
            this.Consent = response.data.Message.Consent;
            this.ExpirationDate = response.data.Message.ExpireIn;
            this.Title = response.data.Message.Title;
            var FixArray = response.data.Message.Tag;

            if (FixArray == "") {
            } else {
              FixArray = FixArray.split(",").map((item) => item.trim());

              this.itemsRequest = FixArray;
            }

            var consent = this.Consent;
            const list = consent
              .sort((a, b) => a.Level - b.Level)
              .map((consent, Level, array) => consent.Level);


            for (var i = 0; i < this.Consent.length; i++) {
              this.SelectConsent = this.Consent;
              this.ItemsData = [];
              var index = 0;
              for (var i in this.SelectConsent) {
                index += 1;
                this.GroupSelect = {
                  ConsentId: this.SelectConsent[i].ConsentId,
                  Level: index,
                  Text: this.SelectConsent[i].HeaderConsent,
                };
                // this.GroupDefault = {
                //   Text: this.SelectConsent[i].HeaderConsent,
                // };
                this.ItemsData.push(this.GroupSelect);
              }

            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                JSON.stringify(error.response.data.ErrorMessage),
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    async Fn_Save() {
      if (this.$refs.form.validate()) {
        this.loadingDownloadData = true;
        var payload = {
          GroupId: this._GroupId,
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          AccessToken: this.$cookies.get("OneAccessToken"),
          GroupName: this.GroupName,
          PolicyId: this.SelectPolicy.PolicyId,
          Consent: this.ItemsData,
          Manage: this.Manage,
          ExpireIn: this.ExpirationDate,
          Title: this.Title,
          Tag: this.itemsRequest.join(", "),
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "group-consent/UpdateDetailGroupConsent",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loadingDraft = false;
            this.loadingEnable = false;
            this.loadingDownloadData = false;

            if (response.data.Status === "OK") {
              this.ItemPolicy = response.data.Message;
              Toast.fire({
                icon: "success",
                title: response.data.Message,
              });
              this.$router.push("/consent-management-group-index");
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loadingDraft = false;
            this.loadingEnable = false;
            this.loadingDownloadData = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: +JSON.stringify(error.response.data.ErrorMessage),
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    save_draft() {
      this.Manage = "draft";
      this.loadingDraft = true;
      this.Fn_Save();
    },
    save_enable() {
      this.Manage = "enable";
      this.loadingEnable = true;
      this.Fn_Save();
    },
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return "";
      } else if (value.includes(" ") == true) {
        return "";
      }
      return !!value || "";
    },
    Fn_BackIndex() {
      this.$router.push("/consent-management-group-index");
    },
  },
  watch: {
    ExpirationDate() {
      if (this.ExpirationDate > 10) {
        this.ExpirationDate = 10;
      }
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.move {
  cursor: move;
}

.FontSize {
  font-size: 14px;
}
</style>
